import cacheRedirects from "graphqlBase/__utils__/cacheRedirects";

const typePolicies = { ...cacheRedirects };

export default typePolicies;
